import {
    apiRequest,
    agamaList,
    agamaActive,
    agamaInactive
} from "../../../../../services/adapters/kepegawaian/agamaService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", agamaList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", agamaInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", agamaActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository